var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React from 'react';
import { connect } from 'react-redux';
import Alert from './Alert';
import { getLatestMessage, flashMessageType, clearMessages as _clearMessages } from 'redux-flash';
export var FlashMessage = function (_React$Component) {
  _inherits(FlashMessage, _React$Component);
  function FlashMessage(props) {
    _classCallCheck(this, FlashMessage);
    var _this = _possibleConstructorReturn(this, (FlashMessage.__proto__ || Object.getPrototypeOf(FlashMessage)).call(this, props));
    _this.handleClose = _this.handleClose.bind(_this);
    return _this;
  }
  _createClass(FlashMessage, [{
    key: 'handleClose',
    value: function handleClose() {
      this.props.clearMessages();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
        flash = _props.flash,
        classes = _props.classes;
      if (flash) {
        var type = flash.props && flash.props.type || (flash.isError ? 'error' : 'success');
        return /*#__PURE__*/React.createElement(Alert, {
          type: type,
          message: flash.message,
          handleClose: this.handleClose
        });
      }
      return null;
    }
  }]);
  return FlashMessage;
}(React.Component);
function mapStateToProps(state) {
  return {
    flash: getLatestMessage(state)
  };
}
function mapDispatchToProps(dispatch) {
  return {
    clearMessages: function clearMessages() {
      dispatch(_clearMessages());
    }
  };
}
FlashMessage.propTypes = {
  flash: flashMessageType
};
export default connect(mapStateToProps, mapDispatchToProps)(FlashMessage);